export const weaponList = [
  {
    name: "Basiliskenzunge",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis:  "50",
    bf: "12"
  },
  {
    name: "Dolch",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis:  "45",
    bf: "12"
  },
  {
    name: "Drachenzahn",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis:  "70",
    bf: "12"
  },
  {
    name: "Linkhand",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis:  "90",
    bf: "12"
  },
  {
    name: "Messer",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "-2",
    rw: "kurz",
    gewicht: "0,25 Stn",
    preis:  "10",
    bf: "12"
  },
  {
    name: "Schwerer Dolch",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Waqqif",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Florett",
    technik: "Fechtwaffen",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "+1",
    pa: "0",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis: "300",
    bf: "12"
  },
  {
    name: "Rapier",
    technik: "Fechtwaffen",
    leiteigenschaft: "GE",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "+1",
    pa: "0",
    rw: "mittel",
    gewicht: "1 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Wolfsmesser",
    technik: "Fechtwaffen",
    leiteigenschaft: "GE",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "+1",
    pa: "+1",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis: "300",
    bf: "12"
  },
  {
    name: "Brabakbengel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+5",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "170",
    bf: "12"
  },
  {
    name: "Keule",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "3",
    bf: "12"
  },
  {
    name: "Knüppel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-2",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis: "0",
    bf: "12"
  },
  {
    name: "Lindwurmschläger",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "1 Stn",
    preis:  "90",
    bf: "12"
  },
  {
    name: "Magierstab, kurz",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis:  "40",
    bf: "12"
  },
  {
    name: "Magierstab, mittel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Molokdeschnaja",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,25 Stn",
    preis:  "95",
    bf: "12"
  },
  {
    name: "Orknase",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+5",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "1,75 Stn",
    preis: "120",
    bf: "12"
  },
  {
    name: "Rabenschnabel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-2",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "105",
    bf: "12"
  },
  {
    name: "Sonnenzepter",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,25 Stn",
    preis: "250",
    bf: "12"
  },
  {
    name: "Streitaxt",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "105",
    bf: "12"
  },
  {
    name: "Streitkolben",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "105",
    bf: "12"
  },
  {
    name: "Morgenstern",
    technik: "Kettenwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+5",
    at: "0",
    pa: "-",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "110",
    bf: "12"
  },
  {
    name: "Kriegslanze",
    technik: "Lanzen",
    leiteigenschaft:  "-",
    schwelle:  "-",
    grundschaden: "2W6",
    bonus: "+6",
    at: "-",
    pa: "-",
    rw: "-",
    gewicht: "3,75 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Schlagring",
    technik: "Raufen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "0,25 Stn",
    preis:  "25",
    bf: "12"
  },
  {
    name: "Waffenlos",
    technik: "Raufen",
    leiteigenschaft: "GE/KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "-",
    preis: "0",
    bf: "12"
  },
  {
    name: "Holzschild",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "",
    at: "-4",
    pa: "+1",
    rw: "kurz",
    gewicht: "3,5 Stn",
    preis:  "50",
    bf: "12"
  },
  {
    name: "Lederschild",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "",
    at: "-4",
    pa: "+1",
    rw: "kurz",
    gewicht: "2 Stn",
    preis:  "30",
    bf: "12"
  },
  {
    name: "Thorwalerschild",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-5",
    pa: "+2",
    rw: "kurz",
    gewicht: "4,5 Stn",
    preis:  "70",
    bf: "12"
  },
  {
    name: "Großschild",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-6",
    pa: "+3",
    rw: "kurz",
    gewicht: "6 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Barbarenschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+5",
    at: "-1",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "140",
    bf: "12"
  },
  {
    name: "Entermesser",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "120",
    bf: "12"
  },
  {
    name: "Flammenschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+7",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1 AsP/KR",
    preis: "0",
    bf: "12"
  },
  {
    name: "Flammenschwert (fern)",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "99",
    grundschaden: "1W6",
    bonus: "+7",
    at: "0",
    pa: "-",
    rw: "32 m | GS8",
    gewicht: "2 AsP/KR",
    preis: "0",
    bf: "12"
  },
  {
    name: "Haumesser",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Khunchomer",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1,25 Stn",
    preis: "210",
    bf: "12"
  },
  {
    name: "Kurzschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis: "140",
    bf: "12"
  },
  {
    name: "Langschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Robbentöter",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Säbel",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "180",
    bf: "12"
  },
  {
    name: "Sklaventod",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1,25 Stn",
    preis: "210",
    bf: "12"
  },
  {
    name: "Dreizack",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "lang",
    gewicht: "2 Stn",
    preis:  "80",
    bf: "12"
  },
  {
    name: "Dschadra",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+5",
    at: "0",
    pa: "-1",
    rw: "lang",
    gewicht: "2 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Hellebarde",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+6",
    at: "0",
    pa: "-2",
    rw: "lang",
    gewicht: "2,5 Stn",
    preis: "160",
    bf: "12"
  },
  {
    name: "Holzspeer",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "0",
    rw: "lang",
    gewicht: "1 Stn",
    preis: "1",
    bf: "12"
  },
  {
    name: "Kampfstab",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "+2",
    rw: "lang",
    gewicht: "1 Stn",
    preis:  "40",
    bf: "12"
  },
  {
    name: "Magierstab, lang",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "+2",
    rw: "lang",
    gewicht: "0,75 Stn",
    preis:  "80",
    bf: "12"
  },
  {
    name: "Speer",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "lang",
    gewicht: "2 Stn",
    preis:  "45",
    bf: "12"
  },
  {
    name: "Zweililie",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "+2",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Anderthalbhänder",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+6",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "320",
    bf: "12"
  },
  {
    name: "Doppelkhunchomer",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+3",
    at: "0",
    pa: "-2",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "320",
    bf: "12"
  },
  {
    name: "Großer Sklaventod",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+3",
    at: "0",
    pa: "-2",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "320",
    bf: "12"
  },
  {
    name: "Rondrakamm",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "340",
    bf: "12"
  },
  {
    name: "Tuzakmesser",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+6",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1,75 Stn",
    preis: "360",
    bf: "12"
  },
  {
    name: "Zweihänder",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+4",
    at: "0",
    pa: "-3",
    rw: "mittel",
    gewicht: "2,5 Stn",
    preis: "360",
    bf: "12"
  },
  {
    name: "Barbarenstreitaxt",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "2W6",
    bonus: "+4",
    at: "0",
    pa: "-4",
    rw: "mittel",
    gewicht: "3,5 Stn",
    preis: "175",
    bf: "12"
  },
  {
    name: "Felsspalter",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "2W6",
    bonus: "+2",
    at: "0",
    pa: "-2",
    rw: "mittel",
    gewicht: "3 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Kriegshammer",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "2W6",
    bonus: "+3",
    at: "0",
    pa: "-3",
    rw: "mittel",
    gewicht: "3 Stn",
    preis: "170",
    bf: "12"
  },
  {
    name: "Zwergenschlägel",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "1W6",
    bonus: "+6",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "3 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Druidendolch",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "0",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Eberfänger",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "1 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Deichgabel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis:  "30",
    bf: "12"
  },
  {
    name: "Turnierlanze",
    technik: "Lanzen",
    leiteigenschaft:  "-",
    schwelle:  "-",
    grundschaden: "1W6",
    bonus: "+8",
    at: "-",
    pa: "-",
    rw: "-",
    gewicht: "3 Stn",
    preis:  "30",
    bf: "12"
  },
  {
    name: "Hirschfänger",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "1 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Turnierschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis:  "20",
    bf: "12"
  },
  {
    name: "Kriegsflegel",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "-1",
    pa: "-1",
    rw: "lang",
    gewicht: "2 Stn",
    preis:  "50",
    bf: "12"
  },
  {
    name: "Saufeder",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+5",
    at: "0",
    pa: "-1",
    rw: "lang",
    gewicht: "1,75 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Sense",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+3",
    at: "-2",
    pa: "-1",
    rw: "lang",
    gewicht: "3,5 Stn",
    preis:  "40",
    bf: "12"
  },
  {
    name: "Sturmsense",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+5",
    at: "-1",
    pa: "-1",
    rw: "lang",
    gewicht: "1,75 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Holzfälleraxt",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "2W6",
    bonus: "+1",
    at: "0",
    pa: "-4",
    rw: "mittel",
    gewicht: "4 Stn",
    preis:  "80",
    bf: "12"
  },
  {
    name: "Stakaxt",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-2",
    rw: "mittel",
    gewicht: "3 Stn",
    preis:  "40",
    bf: "12"
  },
  {
    name: "Andergaster",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+5",
    at: "0",
    pa: "-4",
    rw: "mittel",
    gewicht: "3,25 Stn",
    preis: "400",
    bf: "12"
  },
  {
    name: "Nostrianer",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+5",
    at: "0",
    pa: "-4",
    rw: "mittel",
    gewicht: "3,25 Stn",
    preis: "400",
    bf: "12"
  },
  {
    name: "Turnierzweihänder",
    technik: "Zweihandschwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "-2",
    rw: "mittel",
    gewicht: "2,25 Stn",
    preis:  "40",
    bf: "12"
  },
  {
    name: "Eichhafener",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+5",
    at: "0",
    pa: "-4",
    rw: "mittel",
    gewicht: "3,5 Stn",
    preis: "440",
    bf: "12"
  },
  {
    name: "Harmlyner",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+5",
    at: "0",
    pa: "-4",
    rw: "mittel",
    gewicht: "3,5 Stn",
    preis: "440",
    bf: "12"
  },
  {
    name: "Andergaster Langschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1,25 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Nostrisches Langschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Streitaxt der Streitenden Königreiche",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "105",
    bf: "12"
  },
  {
    name: "Streitkolben der Streitenden Königreiche",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "105",
    bf: "12"
  },
  {
    name: "Turnierschild der Streitenden Königreiche",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "",
    at: "-4",
    pa: "+1",
    rw: "kurz",
    gewicht: "3,5 Stn",
    preis:  "30",
    bf: "12"
  },
  {
    name: "Druidendolch aus Feuerstein",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "0",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Magierstab, lang (aus steineiche)",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "+2",
    rw: "lang",
    gewicht: "1 Stn",
    preis: "380",
    bf: "12"
  },
  {
    name: "Beil",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis:  "20",
    bf: "12"
  },
  {
    name: "Handaxt",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis:  "20",
    bf: "12"
  },
  {
    name: "Fackel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis: "0,5",
    bf: "12"
  },
  {
    name: "Nudelholz",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis:  "10",
    bf: "12"
  },
  {
    name: "Teigholz",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis:  "10",
    bf: "12"
  },
  {
    name: "Schmiedehammer",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "-3",
    rw: "mittel",
    gewicht: "1,25 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Sichel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-2",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis:  "10",
    bf: "12"
  },
  {
    name: "Fuhrmannspeitsche",
    technik: "Peitschen",
    leiteigenschaft: "FF",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "",
    at: "0",
    pa: "-",
    rw: "lang",
    gewicht: "3 Stn",
    preis:  "20",
    bf: "12"
  },
  {
    name: "Breitschwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "-1",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,5 Stn",
    preis: "180",
    bf: "12"
  },
  {
    name: "Parazonium",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis: "140",
    bf: "12"
  },
  {
    name: "Scimshar",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis: "140",
    bf: "12"
  },
  {
    name: "Dreschflegel",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-2",
    pa: "-1",
    rw: "lang",
    gewicht: "1,75 Stn",
    preis:  "30",
    bf: "12"
  },
  {
    name: "Hirtenstab",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "+2",
    rw: "lang",
    gewicht: "0,75 Stn",
    preis:  "10",
    bf: "12"
  },
  {
    name: "Kriegsflegel",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "-1",
    pa: "-1",
    rw: "lang",
    gewicht: "2 Stn",
    preis:  "50",
    bf: "12"
  },
  {
    name: "Pailos",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "2W6",
    bonus: "+3",
    at: "-1",
    pa: "-2",
    rw: "lang",
    gewicht: "4,5 Stn",
    preis: "300",
    bf: "12"
  },
  {
    name: "Sense",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+3",
    at: "-2",
    pa: "-1",
    rw: "lang",
    gewicht: "1,75 Stn",
    preis:  "40",
    bf: "12"
  },
  {
    name: "Sturmsense",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+5",
    at: "-1",
    pa: "-1",
    rw: "lang",
    gewicht: "1,75 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Amazonensäbel",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Faustschild",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "",
    at: "-3",
    pa: "0",
    rw: "kurz",
    gewicht: "1 Stn",
    preis:  "40",
    bf: "12"
  },
  {
    name: "Glefe",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+5",
    at: "0",
    pa: "-2",
    rw: "lang",
    gewicht: "2 Stn",
    preis:  "50",
    bf: "12"
  },
  {
    name: "Hakendolch",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "0",
    rw: "kurz",
    gewicht: "1,25 Stn",
    preis:  "80",
    bf: "12"
  },
  {
    name: "Jagdmesser",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "-2",
    rw: "kurz",
    gewicht: "0,25 Stn",
    preis:  "50",
    bf: "12"
  },
  {
    name: "Jagdspieß",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+5",
    at: "0",
    pa: "-1",
    rw: "lang",
    gewicht: "1,75 Stn",
    preis:  "80",
    bf: "12"
  },
  {
    name: "Katar",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "13",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "1,25 Stn",
    preis:  "50",
    bf: "12"
  },
  {
    name: "Mengbilar",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "-2",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis: "120",
    bf: "12"
  },
  {
    name: "Nachtwind",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1,75 Stn",
    preis: "250",
    bf: "12"
  },
  {
    name: "Ochsenherde",
    technik: "Kettenwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+6",
    at: "-2",
    pa: "-",
    rw: "mittel",
    gewicht: "6 Stn",
    preis: "260",
    bf: "12"
  },
  {
    name: "Ogerfänger",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "1 Stn",
    preis: "100",
    bf: "12"
  },
  {
    name: "Ogerschelle",
    technik: "Kettenwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+2",
    at: "-2",
    pa: "-",
    rw: "mittel",
    gewicht: "4 Stn",
    preis: "180",
    bf: "12"
  },
  {
    name: "Orchidee",
    technik: "Raufen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "1 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Panzerarm",
    technik: "Raufen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "1 Stn",
    preis:  "70",
    bf: "12"
  },
  {
    name: "Richtschwert",
    technik: "Schwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+6",
    at: "-2",
    pa: "-3",
    rw: "mittel",
    gewicht: "5 Stn",
    preis: "600",
    bf: "12"
  },
  {
    name: "Schnitter",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+5",
    at: "-1",
    pa: "-1",
    rw: "lang",
    gewicht: "2 Stn",
    preis:  "80",
    bf: "12"
  },
  {
    name: "Stockdegen",
    technik: "Fechtwaffen",
    leiteigenschaft: "GE",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "+1",
    pa: "0",
    rw: "mittel",
    gewicht: "1 Stn",
    preis: "350",
    bf: "12"
  },
  {
    name: "Warunker Hammer",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+6",
    at: "0",
    pa: "-3",
    rw: "lang",
    gewicht: "3,75 Stn",
    preis: "300",
    bf: "12"
  },
  {
    name: "Besen",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-3",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "0,5",
    bf: "12"
  },
  {
    name: "Bratpfanne",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "-1",
    pa: "-3",
    rw: "kurz",
    gewicht: "2 Stn",
    preis:  "12",
    bf: "12"
  },
  {
    name: "Bratpfanne, heiß",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "-2",
    pa: "-3",
    rw: "kurz",
    gewicht: "2 Stn",
    preis:  "12",
    bf: "12"
  },
  {
    name: "Bratpfanne",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-3",
    pa: "-3",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis: "3",
    bf: "12"
  },
  {
    name: "Flasche",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "-3",
    rw: "kurz",
    gewicht: "",
    preis: "",
    bf: "12"
  },
  {
    name: "Flasche, gesplittert",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-4",
    rw: "kurz",
    gewicht: "",
    preis: "",
    bf: "12"
  },
  {
    name: "Stuhl",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+3",
    at: "-2",
    pa: "-2",
    rw: "mittel",
    gewicht: "",
    preis: "",
    bf: "12"
  },
  {
    name: "Stuhlbein",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-3",
    rw: "mittel",
    gewicht: "",
    preis: "",
    bf: "12"
  },
  {
    name: "Tisch",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "17",
    grundschaden: "1W6",
    bonus: "+4",
    at: "-4",
    pa: "-1",
    rw: "mittel",
    gewicht: "",
    preis: "",
    bf: "12"
  },
  {
    name: "Bratspieß",
    technik: "Hiebwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "-2",
    rw: "mittel",
    gewicht: "3 Stn",
    preis:  "16",
    bf: "12"
  },
  {
    name: "Brecheisen",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "-3",
    rw: "mittel",
    gewicht: "5 Stn",
    preis:  "26",
    bf: "12"
  },
  {
    name: "Seife mit Tuch",
    technik: "Kettenwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W3",
    bonus: "",
    at: "-1",
    pa: "-",
    rw: "mittel",
    gewicht: "0,5 Stn",
    preis: "1",
    bf: "12"
  },
  {
    name: "Wurfhaken mit Kletterseil",
    technik: "Kettenwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-2",
    pa: "-",
    rw: "lang",
    gewicht: "1,5 Stn",
    preis: "7,3",
    bf: "12"
  },
  {
    name: "Brechstange",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "1W6",
    bonus: "+3",
    at: "-1",
    pa: "-3",
    rw: "mittel",
    gewicht: "6 Stn",
    preis:  "38",
    bf: "12"
  },
  {
    name: "Spaten",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "1W6",
    bonus: "+4",
    at: "-2",
    pa: "-4",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "8,5",
    bf: "12"
  },
  {
    name: "Spitzhacke",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "1W6",
    bonus: "+5",
    at: "-1",
    pa: "-5",
    rw: "mittel",
    gewicht: "2,75 Stn",
    preis:  "20",
    bf: "12"
  },
  {
    name: "Shakagra-Giftdolch",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "0,4 Stn",
    preis:  "80",
    bf: "12"
  },
  {
    name: "Shakagra-Hammer",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "1,25 Stn",
    preis: "175",
    bf: "12"
  },
  {
    name: "Shakagra-Buckler",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "",
    at: "-3",
    pa: "+1",
    rw: "kurz",
    gewicht: "3 Stn",
    preis: "250",
    bf: "12"
  },
  {
    name: "Shakagra-Langschild",
    technik: "Schilde",
    leiteigenschaft: "KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-5",
    pa: "+3",
    rw: "kurz",
    gewicht: "5 Stn",
    preis: "500",
    bf: "12"
  },
  {
    name: "Shakagra-Krummsäbel",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Shakagra-Schwert",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+5",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Shakagra-Kriegshammer",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "2W6",
    bonus: "+3",
    at: "0",
    pa: "-3",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "250",
    bf: "12"
  },
  {
    name: "Bannschwert, klein",
    technik: "Dolche",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "0",
    rw: "kurz",
    gewicht: "0,5 Stn",
    preis:  "45",
    bf: "12"
  },
  {
    name: "Bannschwert, mittel",
    technik: "Schwerter",
    leiteigenschaft: "GE/KK",
    schwelle: "15",
    grundschaden: "1W6",
    bonus: "+4",
    at: "0",
    pa: "0",
    rw: "mittel",
    gewicht: "1 Stn",
    preis: "200",
    bf: "12"
  },
  {
    name: "Bannschwert, groß",
    technik: "Zweihandschwerter",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "2W6",
    bonus: "+4",
    at: "0",
    pa: "-3",
    rw: "mittel",
    gewicht: "2,5 Stn",
    preis: "360",
    bf: "12"
  },
  {
    name: "Zauberkugel",
    technik: "Zweihandhiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "13",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "-4",
    rw: "kurz",
    gewicht: "2 Stn",
    preis:  "30",
    bf: "12"
  },
  {
    name: "Zauberstecken, kurz",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "0",
    pa: "-1",
    rw: "kurz",
    gewicht: "0,75 Stn",
    preis:  "30",
    bf: "12"
  },
  {
    name: "Zauberstecken, mittel",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+2",
    at: "0",
    pa: "-1",
    rw: "mittel",
    gewicht: "0,75 Stn",
    preis:  "45",
    bf: "12"
  },
  {
    name: "Zauberstecken, lang",
    technik: "Stangenwaffen",
    leiteigenschaft: "GE/KK",
    schwelle: "16",
    grundschaden: "1W6",
    bonus: "+2",
    at: "-1",
    pa: "+2",
    rw: "lang",
    gewicht: "0,75 Stn",
    preis:  "60",
    bf: "12"
  },
  {
    name: "Laute",
    technik: "Hiebwaffen",
    leiteigenschaft: "KK",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "+1",
    at: "-1",
    pa: "-3",
    rw: "mittel",
    gewicht: "2 Stn",
    preis: "150",
    bf: "12"
  },
  {
    name: "Flöte",
    technik: "Hiebwaffen",
    leiteigenschaft: "GE",
    schwelle: "14",
    grundschaden: "1W6",
    bonus: "",
    at: "-1",
    pa: "-4",
    rw: "kurz",
    gewicht: "0,25 Stn",
    preis: "2",
    bf: "12"
  }
];




// WEBPACK FOOTER //
// ./src/weapon-list.jsx